export default "__VITE_ASSET__DEfyzr6e__"